import { render, staticRenderFns } from "./OutOfStockBrief.vue?vue&type=template&id=3806e26e&"
import script from "./OutOfStockBrief.vue?vue&type=script&lang=js&"
export * from "./OutOfStockBrief.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports